import { Box, Container, Grid, makeStyles, Typography } from "@material-ui/core";
import * as React from "react";
import ContentLeft from "../component/ContentLeft";
import DanhSach from "../component/danhSach/DanhSach";
const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: theme.spacing(4),
    }
}));


export default function DanhSachPage() {
    const classes = useStyles();
    return (
        <Container maxWidth="lg" className={classes.container}>
            <Grid container spacing={2}>
                <Grid item md={3} xs={12} >
                    <ContentLeft />
                </Grid>
                <Grid item md={9} xs={12} >
                    <DanhSach />
                </Grid>
            </Grid>
        </Container>

    );
}